const viewerTemplateScroll = (list) =>{
    let listView = ``;

    for(let i = 0, max = list.length; i < max; i++) {
        listView += `<div class="pswp-navi__thumbnail"><a href="${list[i].src}" class="pswp-navi__thumbnail-link" style="background-image:url(${list[i].src})"></a></div>`;
    }

    return `${listView}`;
};

export default viewerTemplateScroll;